import React, { useState, useEffect } from 'react';

function ConfiguratorOption({ image,title,productCount, filterGuid, onSelect }) {

    const slugify = (text) => {
        return text
            .toLowerCase()
            .trim()
            .replace(/[\s\(\)]+/g, '-')  // Replace spaces and parentheses with hyphens
            .replace(/[^a-z0-9\-]/g, '') // Remove any characters that aren't letters, numbers, or hyphens
            .replace(/-+/g, '-')         // Replace multiple consecutive hyphens with single hyphen
            .replace(/^-|-$/g, '');      // Remove leading/trailing hyphens
    }

    return (
        <div className="icon-container" onClick={() => onSelect(filterGuid)} style={{ cursor: 'pointer' } }>
            <img style={{ width: '150px' }} src={image} id={slugify(title)} alt={title} />
            <div className="title">{title}</div>
            {
                productCount &&
                <div className="products-available">{productCount} Product(s) available</div>
            }
     
        </div>
    );
}

export default ConfiguratorOption;